import React from 'react'
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules'; 
const PlantsCategory = () => {
  return (
    <div className='p-4 rounded-4' style={{backgroundColor:"#BF56C640"}}>
        <div className="d-flex flex-column align-items-center">
            <img src="images/Group 88.png" alt="" />
            <div className="btn-outline-main px-2 py-1 rounded-pill">View all</div>
        </div>
        <Swiper
       className='px-5'
       modules={[Navigation]} 
      navigation 
      spaceBetween={120} 
      breakpoints={{
    640: {
      slidesPerView: 1, 
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 4,
    },
  }}
      loop
    >
        <SwiperSlide>
          <a href='#' className="card text-decoration-none rounded-4 h-100 position-relative">
          <img src="images/flower-5.png" className='category-img' alt="" />
                <div className='price-bg p-3 rounded-bottom-4 text-white text-center'>Green Plants</div>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href='#' className="card text-decoration-none rounded-4 h-100 position-relative">
          <img src="images/flower-5.png" className='category-img' alt="" />
                <div className='price-bg p-3 rounded-bottom-4 text-white text-center'>Flower Plants</div>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href='#' className="card text-decoration-none rounded-4 h-100 position-relative">
          <img src="images/flower-5.png" className='category-img' alt="" />
                <div className='price-bg p-3 rounded-bottom-4 text-white text-center'>Cacti</div>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href='#' className="card text-decoration-none rounded-4 h-100 position-relative">
          <img src="images/flower-5.png" className='category-img' alt="" />
                <div className='price-bg p-3 rounded-bottom-4 text-white text-center'>Hanging Plants</div>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href='#' className="card text-decoration-none rounded-4 h-100 position-relative">
          <img src="images/flower-5.png" className='category-img' alt="" />
                <div className='price-bg p-3 rounded-bottom-4 text-white text-center'>Green Plants</div>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href='#' className="card text-decoration-none rounded-4 h-100 position-relative">
          <img src="images/flower-5.png" className='category-img' alt="" />
                <div className='price-bg p-3 rounded-bottom-4 text-white text-center'>Flower Plants</div>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href='#' className="card text-decoration-none rounded-4 h-100 position-relative">
          <img src="images/flower-5.png" className='category-img' alt="" />
                <div className='price-bg p-3 rounded-bottom-4 text-white text-center'>Cacti</div>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href='#' className="card text-decoration-none rounded-4 h-100 position-relative">
          <img src="images/flower-5.png" className='category-img' alt="" />
                <div className='price-bg p-3 rounded-bottom-4 text-white text-center'>Hanging Plants</div>
          </a>
        </SwiperSlide>
    </Swiper>
    </div>
  )
}

export default PlantsCategory
